import { useState as E, useRef as d, useCallback as h, useEffect as w } from "react";
import { loadGoogleMapScript as R, isBrowser as M } from "../components/Autocomplete/utils/loadGoogleMapScript.js";
const f = "place_result_cache";
function x(c) {
  var a;
  const r = JSON.parse(localStorage.getItem(f) ?? "{}")[c];
  if (!r)
    return;
  const s = Math.floor(Date.now() / 1e3);
  if (!(r.cachedAt + 168 * 3600 < s))
    return (a = r.geometry) != null && a.location && (r.geometry.location = new google.maps.LatLng(
      r.geometry.location.lat,
      r.geometry.location.lng
    )), r;
}
function P(c) {
  const u = JSON.parse(localStorage.getItem(f) ?? "{}");
  c.forEach((r) => {
    r.id && (u[r.id] = {
      ...r.placeResult,
      cachedAt: Math.floor(Date.now() / 1e3)
    });
  }), localStorage.setItem(f, JSON.stringify(u));
}
function S() {
  return new google.maps.places.AutocompleteSessionToken();
}
function k(c) {
  const [u, r] = E(!1), s = d(null), g = d(null), a = d(null), p = d(null), m = d(null), y = h(
    () => R(
      `https://maps.googleapis.com/maps/api/js?key=${c}&libraries=places`
    ),
    [c]
  );
  return w(() => {
    !M || !c || y().then(() => r(!0));
  }, [c]), w(() => {
    u && (g.current = new google.maps.places.AutocompleteService(), a.current = new google.maps.places.PlacesService(
      document.createElement("div")
    ), p.current = new google.maps.Geocoder(), m.current = new google.maps.DistanceMatrixService(), s.current = S());
  }, [u]), {
    isApiReady: u,
    getPredictions: (n, o, i) => new Promise((t, e) => {
      if (g.current === null || s.current === null) {
        e(
          new Error("'autocomplete service is not initilaized yet!'")
        );
        return;
      }
      if (n === "") {
        t([]);
        return;
      }
      const l = {
        input: n,
        types: ["address"],
        sessionToken: s.current,
        locationRestriction: i
      };
      o !== void 0 && (l.componentRestrictions = {
        country: o
      }), g.current.getPlacePredictions(
        l,
        (v) => t(v ?? [])
      );
    }),
    getPlaceDetails: (n) => new Promise(((o, i) => {
      if (a.current === null || s.current === null) {
        i(
          new Error("'place service is not initilaized yet!'")
        );
        return;
      }
      const t = x(n);
      if (t) {
        o(t);
        return;
      }
      a.current.getDetails({
        placeId: n,
        fields: [
          "place_id",
          "formatted_address",
          "address_components",
          "geometry.location"
        ],
        sessionToken: s.current
      }, (e) => {
        s.current = S(), e ? (P([{ id: n, placeResult: e }]), o(e)) : i(
          new Error("'can't get details'")
        );
      });
    })),
    geoLocate: (n, o) => new Promise((i, t) => {
      if (p.current === null) {
        t(
          new Error("'geocode service is not initilaized yet!'")
        );
        return;
      }
      p.current.geocode({
        location: {
          lat: n,
          lng: o
        }
      }, (e) => {
        e ? i(e) : t(
          new Error("'can' get geocode'")
        );
      });
    }),
    getDistanceMatrix: (n, o) => new Promise(
      (i, t) => {
        var e;
        if (m.current === null) {
          t(
            new Error("distance matrix service is not initialized yet!")
          );
          return;
        }
        (e = m.current) == null || e.getDistanceMatrix({
          origins: n,
          destinations: o,
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC
        }, (l) => {
          l ? i(l) : t(
            new Error("'can' get distance matrix'")
          );
        });
      }
    ),
    queryPlace: (n) => new Promise(
      (o, i) => {
        var t;
        if (a.current === null) {
          i(
            new Error("place service is not initilaized yet!")
          );
          return;
        }
        (t = a.current) == null || t.findPlaceFromQuery({
          query: n,
          fields: [
            "formatted_address",
            "place_id",
            "geometry.location"
          ]
        }, (e) => {
          e ? (P(
            e.map((l) => ({
              id: l.place_id,
              placeResult: l
            }))
          ), o(e)) : i(
            new Error("'can't get details'")
          );
        });
      }
    )
  };
}
export {
  k as useMapsApi
};
//# sourceMappingURL=useMapsApi.js.map
